"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.widgetApi = exports.getAllWidgets = exports.getAllWidgetsInLang = exports.fetchWidgetPluginsVariations = void 0;
const fetchWidgetPluginsVariations = (caller) => ({ accountId, testId, variationId }) => {
    const query = {
        _max_per_page: 0,
    };
    return caller(`/api/widget/accounts/${accountId}/tests/${testId}/variations/${variationId}/plugins_variations`).get(query);
};
exports.fetchWidgetPluginsVariations = fetchWidgetPluginsVariations;
const getAllWidgetsInLang = (caller) => ({ lang = 'en_US' }) => {
    const query = {
        _max_per_page: 0,
        lang: lang === 'en_US' ? 'en' : lang,
    };
    return caller(`/api/widget/plugins`).get(query);
};
exports.getAllWidgetsInLang = getAllWidgetsInLang;
const getAllWidgets = (caller) => () => {
    const query = {
        _max_per_page: 0,
    };
    return caller(`/api/widget/plugins`).get(query);
};
exports.getAllWidgets = getAllWidgets;
const widgetApi = (caller) => ({
    getAllWidgets: (0, exports.getAllWidgets)(caller),
    getAllWidgetsInLang: (0, exports.getAllWidgetsInLang)(caller),
    fetchWidgetPluginsVariations: (0, exports.fetchWidgetPluginsVariations)(caller),
});
exports.widgetApi = widgetApi;
//# sourceMappingURL=api.js.map